<template>
  <div id="app" class="app-root">
    <Header/>
    <transition name="route-scale" mode="out-in">
      <router-view />
    </transition>
    <!-- <Footer/> -->
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "App",
  components: {
    Header,
    Footer,
  },
};
</script>

<style>
@import "./styles/fonts.css";

:root {
  --bg: #04566b;

  --tile-empty: #04566b;
  --tile-border: #ffffff;
  --tile-correct: #f04b3b; /* rouge */
  --tile-present: #f4c443; /* jaune */
  --tile-absent: #0c4052;
  --tile-typing: #1b8895;

  --kb-empty: #04566b; /* fond des touches neutres */
  --kb-correct: #f04b3b; /* rouge */
  --kb-present: #f4c443; /* jaune */
  --kb-absent: #616161; /* (peu utilisé maintenant) */

  --text-main: #ffffff;
  --card-bg: #ffffff;
  --card-shadow: #283138;
}

html,
body,
#app {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: "AvenirLTStd", system-ui, -apple-system, BlinkMacSystemFont,
    "Segoe UI", sans-serif;
  background: var(--bg);
  display: flex;
  flex-direction: column;
  /* row-gap: 30px; */
}

.app-root {
  min-height: 100vh;
}

/* Animation de sortie (ancienne view) */
.route-scale-leave-active {
  animation: scaleOut 300ms ease forwards;
}

/* Animation d’entrée (nouvelle view) */
.route-scale-enter-active {
  animation: scaleIn 300ms ease forwards;
}

@keyframes scaleOut {
  0% {
    transform: scale(1);
  }
  30% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(0);
    opacity: 0;
  }
}

@keyframes scaleIn {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  70% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
  }
}
</style>
